import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

const CoreValueItem = ({ data }) => {
  return (
    <div className="flex items-center">
      <div className="mr-4">
        <Img
          src={data.icon.src}
          alt={data.icon.altText}
          width={data.icon.width || 48}
          height={data.icon.height || 48}
          className="h-full w-full"
          wrapper={{ className: "block w-12" }}
        />
      </div>

      <div>
        <Title
          as="h6"
          text={data.title}
          className="mb-4 text-lg font-semibold text-bbc-brand-700"
        />
        {data?.description && <p className="text-black ">{data.description}</p>}
      </div>
    </div>
  );
};

const OurCoreValues = ({ title, description, data }) => {
  return (
    <>
      <div className="container relative z-10">
        <Title
          text={title}
          className="title-h2 mb-6 text-center text-bbc-brand-800 lg:text-left"
        />
        <p className="mb-4 lg:mb-10">{description}</p>
        <div className="row justify-center">
          <div className="order-last space-y-10 lg:col-6 lg:order-first">
            {data.values.length > 0 &&
              data.values.map((item, index) => (
                <CoreValueItem key={index} data={item} />
              ))}
          </div>
          <div className="item-center mb-5 flex justify-center lg:col-6 lg:mb-0">
            <Img
              src={data.image.src}
              alt={data.image.altText}
              width={data.image.width || 472}
              height={data.image.height || 533}
              className="h-full w-full"
              wrapper={{
                className: "block  py-6",
                style: {
                  width: "472px",
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OurCoreValues;

OurCoreValues.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  data: PropTypes.object,
};

OurCoreValues.defaultProps = {
  title: "",
  description: "",
  data: {},
};
